import { Dropdown, Menu } from "antd";
import { DEFAULTS } from "../../constants";
import { logOut } from "../../redux/auth/authThunk";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import ChevronDown from "../Icons/ChevronDown";
import "./style.css"

export const AuthDropdown = () => {
    const { user } = useAppSelector(state => state.auth);

    const dispatch = useAppDispatch();
    return (
        <Dropdown
            trigger={["click"]}
            overlay={
                <Menu
                    items={[
                        {
                            label: (
                                <div className="text-danger cursor-pointer" onClick={() => dispatch(logOut())}>
                                    Logout
                                </div>
                            ),
                            key: "0",
                        },
                    ]}
                />
            }
        >
            <div className="d-flex align-items-center cursor-pointer ms-2">
                <span>
                    <img src={user?.photo || DEFAULTS.avatar} alt="" className="user-profile-image me-2" />
                </span>
                <span className="text-theme mx-2">{user?.name}</span>
                <ChevronDown/>
            </div>
        </Dropdown>
    );
};
